var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowDownloadTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#FFBB38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6112_100709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 16.4258C9.47446 16.4258 9.56984 16.4653 9.64017 16.5356C9.71049 16.6059 9.75 16.7013 9.75 16.8008V18.6758C9.75 18.8747 9.82902 19.0655 9.96967 19.2061C10.1103 19.3468 10.3011 19.4258 10.5 19.4258H19.5C19.6989 19.4258 19.8897 19.3468 20.0303 19.2061C20.171 19.0655 20.25 18.8747 20.25 18.6758V16.8008C20.25 16.7013 20.2895 16.6059 20.3598 16.5356C20.4302 16.4653 20.5255 16.4258 20.625 16.4258C20.7245 16.4258 20.8198 16.4653 20.8902 16.5356C20.9605 16.6059 21 16.7013 21 16.8008V18.6758C21 19.0736 20.842 19.4551 20.5607 19.7364C20.2794 20.0177 19.8978 20.1758 19.5 20.1758H10.5C10.1022 20.1758 9.72064 20.0177 9.43934 19.7364C9.15804 19.4551 9 19.0736 9 18.6758V16.8008C9 16.7013 9.03951 16.6059 9.10983 16.5356C9.18016 16.4653 9.27554 16.4258 9.375 16.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.735 17.8905C14.7698 17.9254 14.8112 17.9531 14.8567 17.972C14.9023 17.9909 14.9511 18.0007 15.0005 18.0007C15.0498 18.0007 15.0986 17.9909 15.1442 17.972C15.1898 17.9531 15.2311 17.9254 15.266 17.8905L17.516 15.6405C17.5864 15.5701 17.6259 15.4746 17.6259 15.375C17.6259 15.2754 17.5864 15.1799 17.516 15.1095C17.4456 15.0391 17.3501 14.9995 17.2505 14.9995C17.1509 14.9995 17.0554 15.0391 16.985 15.1095L15.3755 16.7198V10.125C15.3755 10.0255 15.336 9.93016 15.2656 9.85983C15.1953 9.78951 15.0999 9.75 15.0005 9.75C14.901 9.75 14.8056 9.78951 14.7353 9.85983C14.665 9.93016 14.6255 10.0255 14.6255 10.125V16.7198L13.016 15.1095C12.9456 15.0391 12.8501 14.9995 12.7505 14.9995C12.6509 14.9995 12.5554 15.0391 12.485 15.1095C12.4146 15.1799 12.375 15.2754 12.375 15.375C12.375 15.4746 12.4146 15.5701 12.485 15.6405L14.735 17.8905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6112_100709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowDownloadTableIcon);
export default __webpack_public_path__ + "static/media/yellow-download-table-icon.4d656bd90ae662ca0c27bbd2b6d6bca4.svg";
export { ForwardRef as ReactComponent };